import type { DrawerItem } from '@/components/subject/configs.ts';

const experiments: DrawerItem[] = [
  // {
  //   title: '5.二次函数',
  //   icon: 'lucide:folder',
  //   children: [
  //     { title: '二次函数可视化', icon: 'lucide:flask-conical', route: `/experiment/quadratic-function` },
  //   ],
  // },
];

const experimentConfig = {
  experiments,
};

export { experimentConfig };
